/**
 * Created by developer1 on 30.03.2017.
 */
$(function () {
    var filters = {
        criterias: {},
        filter: function ($elements) {
            if (Object.keys(this.criterias).length > 0) {
                this.exclude = $elements;
                this.include = $elements;
                for (var criteria in this.criterias) {
                    if (criteria) {
                        this.exclude = this.exclude.not(criteria);
                        this.include = this.include.filter(criteria);
                    }
                }
                $elements.stop().animate({opacity: 0.1}).addClass('hidden');
                $(this.include).stop().animate({opacity: 1}).removeClass('hidden');
            } else {
                $elements.stop().animate({opacity: 1}).removeClass('hidden');
            }
            this.team_check();
            console.log('%cФильтрация:', 'color: green', this.criterias)
        },

        team_check: function () {
            var $blocks = $('.coaches-team');
            $blocks.each(function () {
                var $this = $(this);
                var collection = $this.find('[data-coaches-filter]').not('.hidden');
                if(collection.length < 1){
                    $this.hide();
                }else{
                    $this.show();
                }
            });
        },
        include: null,
        exclude: null
    };
    $(document).on('change', '[js-coaches-filter]', function (e) {
        var $this = $(this);
        $this.trigger('filter:coaches');
    })
    .on('filter:coaches', function (e) {
        var $target = $(e.target);
        filters.criterias = {};
        $('[js-coaches-filter]').each(function () {
            var $this = $(this);
            if($this.prop('checked')){
                filters.criterias[$this.attr('js-coaches-filter')] = $this.attr('js-coaches-filter');
            }
        });
        filters.filter($('[data-coaches-filter]'));
    });

    $(document).on('click', '[js-show-details]', function (e) {
        e.preventDefault();
        var $this = $(this),
            $modal = $($this.data('modal'));
        $$.openModal($modal);
    });

});